module.exports = require("lodash/compact");